import { Text } from "@/components/podkit/typography/Text";
import { isNoSuitableRunnerFoundError } from "@/routes/environments/create/create-environment-utils";
import { formatError } from "@/utils/errors";
import { ConnectError } from "@connectrpc/connect";
import { PolicyEnforcedFailedPreconditionDetails } from "gitpod-next-api/gitpod/v1/organization_pb";
import { useMemo, type FC } from "react";

export const EnvironmentCreateError: FC<{ error: Error }> = ({ error }) => {
    const errorMessage = useMemo(() => {
        if (error instanceof ConnectError) {
            const details = error.findDetails(PolicyEnforcedFailedPreconditionDetails);
            if (details.length > 0) {
                switch (details[0].policyName) {
                    case "maximum_running_environments_per_user":
                        return "You have reached the maximum number of concurrent environments set by your organization.";
                    case "maximum_environments_per_user":
                        return "You have reached the maximum total number of environments set by your organization.";
                    default:
                        return details[0].message;
                }
            } else {
                if (isNoSuitableRunnerFoundError(error)) {
                    return "No available runner found";
                }

                return error.rawMessage;
            }
        }

        return formatError(error);
    }, [error]);

    return <Text className="text-sm">{errorMessage}</Text>;
};
